import { PayloadAction, createSlice } from "@reduxjs/toolkit"

import { logout } from "../../../login/loginSlice"

export type SelectedPriceListId = number | "NONE" | null

/**
 * Areas that remember their own price list selection independently.
 * `products` is shared by the Products list and the Create product form.
 */
export type PriceListSelectionScope = "products" | "productGroups"

type ScopedSelections = Record<PriceListSelectionScope, SelectedPriceListId>

type PriceListSelectionState = Readonly<{
    merchantId: number | null
    selectedByScope: ScopedSelections
}>

const emptySelections: ScopedSelections = {
    products: null,
    productGroups: null,
}

const initialState: PriceListSelectionState = {
    merchantId: null,
    selectedByScope: emptySelections,
}

const priceListSelectionSlice = createSlice({
    name: "priceListSelection",
    initialState,
    reducers: {
        setSelectedPriceList: (
            state,
            action: PayloadAction<{
                merchantId: number
                scope: PriceListSelectionScope
                priceListId: SelectedPriceListId
            }>,
        ) => {
            const { merchantId, scope, priceListId } = action.payload
            if (state.merchantId !== merchantId) {
                state.merchantId = merchantId
                state.selectedByScope = { ...emptySelections }
            }
            state.selectedByScope[scope] = priceListId
        },
    },
    extraReducers(builder) {
        builder.addCase(logout, (state) => {
            state.merchantId = null
            state.selectedByScope = { ...emptySelections }
        })
    },
})

export const { setSelectedPriceList } = priceListSelectionSlice.actions
export const priceListSelectionReducer = priceListSelectionSlice.reducer

